import { render } from "./laborEventClub.vue?vue&type=template&id=4e6ff9c2"
import script from "./laborEventClub.vue?vue&type=script&lang=js"
export * from "./laborEventClub.vue?vue&type=script&lang=js"

import "./laborEventClub.vue?vue&type=style&index=0&id=4e6ff9c2&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__